import React from "react";
import PropTypes from 'prop-types';
import { Subscriber } from "react-broadcast";

var Frame = function Frame(_ref) {
  var stack = _ref.stack,
      frame = _ref.frame,
      exact = _ref.exact,
      children = _ref.children;
  return React.createElement(
    Subscriber,
    { channel: stack },
    function (_ref2) {
      var dispatch = _ref2.dispatch,
          index = _ref2.index;

      if (exact ? frame === index : frame <= index) return children(dispatch);
      return null;
    }
  );
};

Frame.defaultProps = {
  stack: 'slides',
  frame: 0,
  exact: true
};

Frame.propTypes = {
  stack: PropTypes.string,
  frame: PropTypes.number,
  exact: PropTypes.bool,
  children: PropTypes.func
};

export default Frame;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-framestack/lib/Frame.js
// module id = 39
// module chunks = 0